(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumimuse-specifications"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lumimuse-specifications')) {
  class LumiMuseSpecifications extends HTMLElement {
    connectedCallback() {
      this.onVariant = (event) => {
        // A form control named "id" shadows form.id in this theme. Read the attribute.
        const formId = event.target instanceof HTMLFormElement ? event.target.getAttribute('id') : event.detail?.formId;
        if (typeof formId !== 'string' || !formId.startsWith(`product-form-main-${this.dataset.productId}-`)) return;
        this.showVariant(event.detail.variant?.id);
      };
      document.addEventListener('variant:changed', this.onVariant);
      this.showVariant(this.dataset.initialVariant);
    }
    disconnectedCallback() {
      document.removeEventListener('variant:changed', this.onVariant);
    }
    showVariant(id) {
      const wanted = id == null ? '' : String(id);
      let found = false;
      for (const panel of this.querySelectorAll('[data-variant-id]')) {
        const matches = panel.dataset.variantId === wanted;
        panel.hidden = !matches;
        found = found || matches;
      }
      this.querySelector('.lumimuse-spec-unavailable').hidden = found;
    }
  }
  customElements.define('lumimuse-specifications', LumiMuseSpecifications);
}

  } catch(e) { console.error(e); }
})();
})();
